import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../src/component/Header";
import IconPen from "../../../src/component/SvgIcons/IconPen";
import IconUpdownFilter from "../../../src/component/SvgIcons/IconUpdownFilter";
import api from "../../Services/api";
import Pagination from "../../component/Pagination";
import IconSearch from "../../component/SvgIcons/IconSearch";
import IconRenewal from "../../component/SvgIcons/IconRenewal";
import { Tooltip } from "react-tooltip";


import { formatCountryDate } from "../../Services/countryTime";
export default function NewLicence() {
  const [users, setUsers] = useState([]); // Ensures users is always an array
  const [selectedCountry, setSelectedCountry] = useState("All Countries"); 
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);  
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1920) {
        setItemsPerPage(20);
      } else {
        setItemsPerPage(10);
      }
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

  useEffect(() => {
    const fetchLicences = async () => {
      try {
        const response = await api.post("/getAllLicences");        
        console.log("API Response:", response.data);  
  
        // Adjust based on API response structure
        setUsers(Array.isArray(response.data.data) ? response.data.data : []);
  
      } catch (error) {
        console.error("Error fetching licences:", error);
        setUsers([]); // Prevent crashes by setting an empty array
      }
    };
  
    fetchLicences();
  }, []);
  
  const countryOptions = [...new Set(users.map(user => user.country))].filter(Boolean);
  // Handle sorting
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };
  // Sort data based on selected column
  const sortedUsers = [...users].sort((a, b) => {
    if (!sortConfig.key) return 0;
    return sortConfig.direction === "asc"
      ? a[sortConfig.key].localeCompare(b[sortConfig.key])
      : b[sortConfig.key].localeCompare(a[sortConfig.key]);
  });

  // Filter based on search input
  const filteredPrice = sortedUsers.filter((user) => {
    const country = user.country ? user.country.toLowerCase() : "";
    const product = user.product_name ? user.product_name.toLowerCase() : "";

    // Format date to DD-MM-YYYY for searching
    const formattedDate = formatCountryDate(user.DateTime)
      .replace(/\//g, "-");
  
    const matchesSearch = 
      country.includes(searchQuery.toLowerCase()) || 
      product.includes(searchQuery.toLowerCase()) ||
      formattedDate.includes(searchQuery); // ✅ Match formatted date      
    const matchesCountry = 
    selectedCountry === "All Countries" || user.country === selectedCountry; 
    return matchesSearch && matchesCountry;
  });
  

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredPrice.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPrice.length / itemsPerPage);

  
  // Pagination logic
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <section className="eventpage">
      <Header pageTitle="New License Price List" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="/renewal-licence" className="btn btn-purpal addbutton">
              <IconRenewal /> Renewal Licence
            </Link>

            <select
              className="form-select"
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="All Countries">All Countries</option>
              {countryOptions.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </select>
            <Link to="#" onClick={() => handleSort("price")}>
              <IconUpdownFilter />
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Here.."
            />
            {/* <label htmlFor="name">Search</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10px" align="center">
                    Sr. No.
                  </th>
                  <th>Date</th>
                  <th>Country Name</th>
                  <th>Product Name</th>
                  <th>Pricing</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user.id}>
                      <td align="center">{index + 1}</td>
                      <td>
                        {formatCountryDate(user.DateTime)
                          .replace(/\//g, "-")}
                      </td>
                      <td>{user.country}</td>
                      <td>{user.product_name}</td>
                      <td>{user.price}</td>
                      <td>
                        <Link
                          to={`/edit-new-licence/${user.id}`}
                          className="action"
                          style={{ display: "block" }}
                          data-tooltip-id={`edit-${user.id}`}
                          data-tooltip-content="Edit"
                        >                       
                          <IconPen />
                        </Link>
                        <Tooltip id={`edit-${user.id}`} place="top" />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={filteredPrice.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
